import React, { SyntheticEvent } from "react";
import { makeStyles } from "@mui/styles";
import KrgDatePicker, {
  DateRange,
} from "@kargo/shared-components.krg-date-picker";

const useStyles = makeStyles({
  readOnlyDatePicker: {
    "& input": {
      pointerEvents: "none !important",
      cursor: "default !important",
      backgroundColor: "transparent !important",
      caretColor: "transparent !important", // Hide text cursor
    },
    "& .MuiInputAdornment-root": {
      pointerEvents: "all !important",
    },
    "& .MuiInputBase-root": {
      cursor: "default !important",
    },
    "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(0, 0, 0, 0.23) !important", // Prevent hover border change
    },
  },
});

type Props = {
  isEnabled?: boolean;
  value?: DateRange | undefined;
  onDateRangeChange?: (date: DateRange | undefined) => any;
  onDateClear?: () => any;
  onClick?: (ev?: SyntheticEvent) => any;
};

export function DatePicker({
  isEnabled,
  value,
  onDateRangeChange,
  onDateClear,
  onClick,
}: Props) {
  const classes = useStyles();

  return (
    <KrgDatePicker
      dateRange={value}
      classNames={{
        input: classes.readOnlyDatePicker,
      }}
      inputVariant={KrgDatePicker.VARIANT_ENUM.outlined}
      placeholder="Select date range"
      isRange
      isEnabled={isEnabled}
      onDateRangeChange={onDateRangeChange}
      onDateClear={onDateClear}
      onClick={onClick}
    />
  );
}

export type { DateRange };
